import { SideNavInterface } from '../../interfaces/side-nav.type';
export const ROUTES: SideNavInterface[] = [
    // {
    //     path: '/dashboard',
    //     title: 'Dashboard',
    //     iconType: 'nzIcon',
    //     iconTheme: 'outline',
    //     icon: 'dashboard',
    //     submenu: []
    // },
    {
        path: '/resources',
        title: 'Resource Manager',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'file-search',
        submenu: [
        ]
    },
    {
        path: '/groups',
        title: 'Access Groups',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'group',
        submenu: [
        ]
    },
    // {
    //     path: '/events',
    //     title: 'Events',
    //     iconType: 'nzIcon',
    //     iconTheme: 'outline',
    //     icon: 'calendar',
    //     submenu: [
    //         // {
    //         //     path: '/event',
    //         //     title: 'Event list',
    //         //     iconType: 'nzIcon',
    //         //     iconTheme: 'outline',
    //         //     icon: 'dashboard',
    //         //     submenu: []
    //         // },
    //     ]
    // },
    {
        path: '/knowledge-base',
        title: 'Knowledge Base',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'book',
        submenu: [
        ]
    },
    {
        path: '/academy',
        title: 'Academy',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'desktop',
        submenu: [
        ]
    },
    {
        path: '/notification',
        title: 'Notifications',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'notification',
        submenu: []
    },
    {
        path: '/newsletter',
        title: 'Newsletter',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'mail',
        submenu: [
        ]
    },
    {
        path: '/user-panel',
        title: 'User panel',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'usergroup-delete',
        submenu: [
        ]
    },
    {
        path: '',
        title: 'Analytics',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'bar-chart',
        submenu: [],
        externalUrl: 'https://us.posthog.com/login',
    },
] 